import React, { useState, useEffect } from 'react';
import { getPPDListApi } from '../../../services/OtherService';
import TableLoaderEffect from '../../constant/TableLoader';
import { Link } from 'react-router-dom';

const PPDListPage = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)


    useEffect(() => {
        setIsLoading(true)
        getPPDListApi().then((resp) => {
            setData(resp.data)
            setIsLoading(false)
        }).catch((error) => {
            console.log(error.response.data)
            setIsLoading(false)
        })

    }, [])


    const handleSearchChange = (e) => {
        const { value } = e.target
        setSearchQuery(value)
    }


    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Petty Purchase Demand List</h4>
                                        <div className='d-flex'>
                                            <div className='form-group me-5'>
                                                <input type="search" name="serach" className="form-control"
                                                    placeholder="Search"
                                                    value={searchQuery} onChange={handleSearchChange} />
                                            </div>
                                            <Link to="/add-purchase-demand" className="btn btn-primary ms-1">Add PPD</Link>
                                        </div>
                                    </div>

                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>MMG Demand Number</th>
                                                    <th>Project Name & No.</th>
                                                    <th>Project Build Up</th>
                                                    <th>Initiated By</th>
                                                    <th>Initiated At</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading ? <TableLoaderEffect colLength={6} /> : data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <Link className='text-primary cursor-pointer fw-bolder' to={`/view-purchase-demand/${item.id}`}>{item.mmg_demand_no}</Link>
                                                        </td>
                                                        <td><span>{item.project_name_no}</span></td>
                                                        <td>{item.project_build_up}</td>
                                                        <td><span>{item.initiated_by.name}</span></td>
                                                        <td><span>{item.initiated_at}</span></td>
                                                        <td>
                                                            {item.status === "Pending" ? (
                                                                <span className={`badge light border-0 badge-warning`}>Pending</span>
                                                            ) : item.status === "Reviewed" ? (
                                                                <span className={`badge light border-0 badge-info`}>Reviewed</span>
                                                            ) : item.status === "Approved" ? (<span className={`badge light border-0 badge-success`}>Approved</span>) :
                                                                (<span className={`badge light border-0 badge-danger`}>Rejected</span>)}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PPDListPage;

